// Trigger UI deployment build
export const environment = {
  masterDataBaseUrl: 'https://dev-promo.ocadohub.com/api/v1/',
  promotionBaseUrl: 'https://dev-promo.ocadohub.com/api/v1/',
  proposalBaseUrl: 'https://dev-promo.ocadohub.com/api/v1/',
  productBaseUrl: 'https://dev-promo.ocadohub.com/api/v1/',
  workFlowBaseUrl: 'https://dev-promo.ocadohub.com/api/v1/',
  dashboardBaseUrl: 'https://dev-promo.ocadohub.com/api/v1/',
  supplierBaseUrl: 'https://dev-promo.ocadohub.com/api/v1/',
  authBaseUrl: 'https://dev-promo.ocadohub.com/api/v1/',
  uploadDownloadBaseUrl: 'https://dev-promo.ocadohub.com/api/v1/',
  conflictcheckBaseUrl: 'https://dev-promo.ocadohub.com/api/v1/',
  integrationasyncBaseurl: 'https://dev-promo.ocadohub.com/api/v1/',
  masterDataStoreCacheUrl:
    'https://dev-promo.ocadohub.com/api/v1/lov/store-cache',
  masterDataStoreRedisUrl:
    'https://dev-promo.ocadohub.com/api/v1/lov/store-cache',
  customerGroupUrl: 'https://dev-promo.ocadohub.com/api/v1/',
  baseUrl: 'https://dev-promo.ocadohub.com',
  socketPath: '/api/v1/socket',
  clientId: 'JMo2Q9odfoBYKoqOhDUdexOgGtwmNAy6',
  auth0Domain: 'dev-auth.ocadohub.com',
  audience: 'https://promo.ocadohub.com/v1',
  isProd: false,
  useLegacy: true,
  v2BaseUrl: 'https://dev-promo.ocadohub.com/api/v2',
};
